'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Products = undefined;

var _Products2 = require('./Products');

var _Products3 = _interopRequireDefault(_Products2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Products = _Products3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Products/index.js
// module id = 1741
// module chunks = 0